import React from 'react';

const PurchaseDetailsForm = ({ formData, onChange, errors }) => {
  return (
    <div className="bg-white overflow-hidden sm:rounded-lg border border-gray-200">
      <div className="px-6 py-5 sm:px-8 bg-white border-b border-gray-200">
        <div className="flex items-center">
          <div className="p-2 rounded-md bg-[#f5f8f7] mr-4">
            <svg className="h-6 w-6 text-[#174540]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">Détails de l'achat</h3>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">
              Information de base pour cet achat
            </p>
          </div>
        </div>
      </div>

      <div className="px-6 py-6 sm:px-8 sm:py-7 bg-white">
        <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
          {/* Reference field */}
          <div className="sm:col-span-3">
            <label htmlFor="reference" className="block text-sm font-medium text-gray-700 mb-1 flex items-center">
              Référence <span className="text-red-500 ml-1">*</span>
            </label>
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-4 w-4 text-gray-400 group-hover:text-[#174540] transition-colors duration-200" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14" />
                </svg>
              </div>
              <input
                type="text"
                name="reference"
                id="reference"
                value={formData.reference}
                onChange={onChange}
                className={`pl-10 py-3 shadow-sm block w-full border-0 border-b-2 border-gray-200 focus:ring-0 focus:border-[#174540] transition-all duration-300 ease-in-out text-sm rounded-t-md ${errors['reference'] ? 'border-red-300 text-red-900 placeholder-red-300' : ''}`}
              />
              {errors['reference'] && (
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                </div>
              )}
            </div>
            {errors['reference'] && <p className="mt-2 text-sm text-red-600">{errors['reference']}</p>}
          </div>

          {/* Date field */}
          <div className="sm:col-span-3">
            <label htmlFor="datePurchase" className="block text-sm font-medium text-gray-700 mb-1">
              Date de l'achat
            </label>
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-4 w-4 text-gray-400 group-hover:text-[#174540] transition-colors duration-200" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <input
                type="datetime-local"
                name="datePurchase"
                id="datePurchase"
                value={formData.datePurchase}
                onChange={onChange}
                className="pl-10 py-3 shadow-sm block w-full border-0 border-b-2 border-gray-200 focus:ring-0 focus:border-[#174540] transition-all duration-300 ease-in-out text-sm rounded-t-md"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseDetailsForm;